export class StringUtil {
  static formatPrice(price: number) {
    return price.toLocaleString('vi-VN', {
      style: 'currency',
      currency: 'VND',
    });
  }
}
